export { default as LoyaltyLoadingAnimation } from './loyalty-loading-animation.bk.json';
export { default as LoyaltyPullDownLoader } from './loyalty-pull-down-loader.bk.json';
